import React from 'react';

import {
  SearchResult,
} from '../../../components';

import LandingPageFull from './Full';

const LandingPage = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'full':
    default:
      return (<LandingPageFull entity={entity} {...props} />);
  }
};

export default LandingPage;
